import { LicenseStatusTypes } from './license';
import { BillingCycleTypes } from './invoice';
import { MemberPersonTypes } from './member';

export interface IAdvancedSearchItem  {

    IsAdvancedSearch: boolean;
    AlwaysIncludeLicenses: boolean;
    OnlySearchMembers: boolean;

    MemberID: number;
    MaxRecords: number;

    // SMART SEARCH
    SmartSearch: string;

    // NAME
    FirstName: string;
    LastName: string;

    MemberType: MemberPersonTypes[];

    IncludeDesignerLicenses: boolean;

    // CONTACT
    Email: string;
    CompanyName: string;
    Address1: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    Phone1: string;
    Phone2: string;
    Fax: string;

    // SALES
    SalesRepID: number[];

    // BILLING
    CreditCardLastFour: string;
    BillingCycle: BillingCycleTypes[];
    NextBillDate: Date;
    NextBillDateEnd: Date;
    BillingAmount: number;

    // PRODUCT
    CDKey: string;
    Version: string;
    LiveHubVersion: string;
    DesignerName: string;
    ProductID: number[];
    Status: LicenseStatusTypes[];

    CreationDate: Date;
    CreationDateEnd: Date;

    ExpirationDate: Date;
    ExpirationDateEnd: Date;

    ExcludeFreeLicenses: boolean;

    // TAGS
    TagIDs: number[];

    // /////////////////////////
    // SHOW DATA COLUMN BOOLS
    // /////////////////////////
    showMemberID: boolean;
    showFirstName: boolean;
    showLastName: boolean;
    showEmail: boolean;
    showCompanyName: boolean;
    showAddress1: boolean;
    showCity: boolean;
    showState: boolean;
    showZipCode: boolean;
    showCountry: boolean;
    showPhone1: boolean;
    showPhone2: boolean;
    showFax: boolean;
    showSalesRep: boolean;
    showCreditCardLastFour: boolean;
    showBillingCycle: boolean;
    showNextBillDate: boolean;
    showBillingAmount: boolean;
    showCDKey: boolean;
    showVersion: boolean;
    showDesignerName: boolean;
    showProductID: boolean;
    showStatus: boolean;
    showCreationDate: boolean;
    showExpirationDate: boolean;
    showMemberType: boolean;
    showTags: boolean;
    showAuthorizedFirstname: boolean;
    showAuthorizedLastName: boolean;
    showAuthorizedEmail: boolean;
}


export class AdvancedSearchItem implements IAdvancedSearchItem {

    IsAdvancedSearch: boolean;
    AlwaysIncludeLicenses: boolean;
    OnlySearchMembers: boolean;

    MemberID: number;
    MaxRecords: number = 100;
    SkipRecords: number = 0;

    // SMART SEARCH
    SmartSearch: string;

    // NAME
    FirstName: string;
    LastName: string;
    IncludeDesignerLicenses: boolean;
    MemberType: MemberPersonTypes[];

    // CONTACT
    Email: string;
    CompanyName: string;
    Address1: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    Phone1: string;
    Phone2: string;
    Fax: string;

    // SALES
    SalesRepID: number[];

    // BILLING
    CreditCardLastFour: string;
    BillingCycle: BillingCycleTypes[];
    NextBillDate: Date;
    NextBillDateEnd: Date;
    BillingAmount: number;

    // PRODUCT
    CDKey: string;
    Version: string;
    LiveHubVersion: string;
    DesignerName: string;
    ProductID: number[];
    Status: LicenseStatusTypes[];
    CreationDate: Date;
    CreationDateEnd: Date;
    ExpirationDate: Date;
    ExpirationDateEnd: Date;

    ExcludeFreeLicenses: boolean;

    // TAGS
    TagIDs: number[];

    // /////////////////////////
    // SHOW DATA COLUMN BOOLS
    // /////////////////////////
    showMemberID: boolean;
    showFirstName: boolean;
    showLastName: boolean;
    showEmail: boolean;
    showCompanyName: boolean;
    showAddress1: boolean;
    showCity: boolean;
    showState: boolean;
    showZipCode: boolean;
    showCountry: boolean;
    showPhone1: boolean;
    showPhone2: boolean;
    showFax: boolean;
    showSalesRep: boolean;
    showCreditCardLastFour: boolean;
    showBillingCycle: boolean;
    showNextBillDate: boolean;
    showBillingAmount: boolean;
    showCDKey: boolean;
    showVersion: boolean;
    showDesignerName: boolean;
    showProductID: boolean;
    showStatus: boolean;
    showCreationDate: boolean;
    showExpirationDate: boolean;
    showMemberType: boolean;
    showTags: boolean;
    showAuthorizedFirstname: boolean;
    showAuthorizedLastName: boolean;
    showAuthorizedEmail: boolean;
}
